import * as React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import Svg, { Path } from 'react-native-svg';

const PlusBackground = React.memo(
  (props: {
    width?: number;
    height?: number;
    color?: string;
    containerStyle?: StyleProp<ViewStyle>;
  }) => {
    return (
      <View style={props.containerStyle}>
        <Svg
          width={props.width ?? 100}
          height={props.height ?? 94}
          viewBox="0 0 100 94"
          fill="none"
        >
          <Path
            d="M65.5037 93.1209H35.3943V58.3792H0.863281V34.1654H35.3943V0.476562H65.5037V34.1654H99.8242V58.3792H65.5037V93.1209Z"
            fill={props.color ?? '#FFF5DD'}
            fillOpacity="0.95"
          />
        </Svg>
      </View>
    );
  },
);

export { PlusBackground };
